const ChatbotActions = {
  CHATBOT_LIST_LOADED: "chatbot-list/loaded",
  CHATBOT_LOADED: "chatbot/loaded",
  MESSAGES_LOADED: "chatbot/messages/loaded",
  KBPAGES_LOADED: "chatbot/kbpages/loaded",
};

export default ChatbotActions;
